import { useSetPlayerStoreData } from '../hooks'

export const useSetPlayerData = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()

  const setPlayerData = data => {
    setPlayerStoreData(data, 'setPlayerData')
  }

  return { setPlayerData }
}
